import * as React from "react";
// Remember that all const are suffix _svg

const rotate_svg = (
  <svg
    className={"rotate_svg"}
    width="87"
    height="86"
    viewBox="0 0 87 86"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.375 76.9296L32.2461 72.2264L45.8516 85.8319L43.5 85.9999C32.3021 85.9999 22.5599 82.1926 14.2734 74.578C6.09896 66.9634 1.5638 57.6132 0.667969 46.5272H6.04297C6.71484 53.246 8.95443 59.2928 12.7617 64.6678C16.569 70.0428 21.4401 74.1301 27.375 76.9296ZM53.5781 75.9218L76.4219 53.078L33.4219 10.078L10.5781 32.9218L53.5781 75.9218ZM37.1172 6.21472L80.2852 49.3827C81.4049 50.3905 81.9648 51.6223 81.9648 53.078C81.9648 54.5337 81.4049 55.8215 80.2852 56.9413L57.4414 79.785C56.4336 80.9048 55.2018 81.4647 53.7461 81.4647C52.2904 81.4647 51.0026 80.9048 49.8828 79.785L6.71484 36.6171C5.59505 35.6093 5.03516 34.3775 5.03516 32.9218C5.03516 31.466 5.59505 30.1783 6.71484 29.0585L29.5586 6.21472C30.5664 5.09493 31.7982 4.53503 33.2539 4.53503C34.7096 4.53503 35.9974 5.09493 37.1172 6.21472ZM59.625 9.07019L54.7539 13.7733L41.1484 0.167847L43.5 -0.00012207C54.6979 -0.00012207 64.3841 3.80717 72.5586 11.4218C80.845 19.0363 85.4362 28.3866 86.332 39.4725H80.957C80.2852 32.7538 78.0456 26.7069 74.2383 21.3319C70.431 15.9569 65.5599 11.8697 59.625 9.07019Z"
      fill="#FF3829"
    />
  </svg>
);

export { rotate_svg };
